import React from 'react';
import UiPartRenderer from './UiPartRenderer';
import { bubbleUiParts } from './uiActionLabel';

export default function MessageWithParts({
  content,
  uiParts = [],
  onAction,
  disabled,
  frozen = false,
  dir = 'ltr',
  markdownComponent: Markdown,
  afterContent = null,
}) {
  const visibleParts = bubbleUiParts(uiParts);

  return (
    <div className={`message-with-parts${frozen ? ' message-with-parts--frozen' : ''}`} dir={dir}>
      {content && Markdown ? <Markdown content={content} /> : content ? <p>{content}</p> : null}
      {afterContent}
      {visibleParts.map((part) => (
        <UiPartRenderer
          key={part.part_id}
          part={part}
          onAction={frozen ? undefined : onAction}
          disabled={disabled || frozen}
          dir={dir}
        />
      ))}
    </div>
  );
}
